<template>
  <div>
    <el-badge :value="total > 99 ? 99 + '+' : total">
      <el-popover placement="bottom" width="200" trigger="click">
        <!-- <el-button slot="reference">click 激活</el-button> -->
        <div slot="reference" class="" @click="getNewList()">
          <vab-icon icon="notification-line" />
          <!-- <span style="cursor: pointer">消息</span> -->
        </div>
        <div class="messageList">
          <div
            v-for="(item, index) of messageList"
            :key="index"
            class="messageList-item"
            @click="goto(item)"
          >
            {{ item.desc }}
            <el-button type="text">({{ item.count }})</el-button>
          </div>
        </div>
      </el-popover>
    </el-badge>
  </div>
</template>

<script>
  import { homepageNoticeList, homeMenuAdd } from '@/api/common.js'
  export default {
    name: 'VabNotice',
    data() {
      return {
        messageShow: false,
        messageList: [],
        total: 0,
      }
    },
    computed: {},
    created() {
      // 隐藏
      this.getList()
    },
    methods: {
      getNewList() {
        this.getList()
      },
      getList() {
        homepageNoticeList().then((res) => {
          this.total = 0
          res.data.forEach((item) => {
            this.total += item.count
          })
          this.messageList = res.data
        })
      },
      goto(row) {
        homeMenuAdd({ path: row.name }).then(() => {
          this.$router.push({
            name: row.name,
            query: row.url ? JSON.parse(row.url) : {},
          })
        })
      },
    },
  }
</script>

<style lang="scss" scoped>
  :deep() {
    .el-tabs__active-bar {
      min-width: 28px;
    }
  }

  .notice-list {
    height: 29vh;

    ul {
      padding: 0 15px 0 0;
      margin: 0;

      li {
        display: flex;
        align-items: center;
        padding: 10px 0 10px 0;

        :deep() {
          .el-avatar {
            flex-shrink: 0;
            width: 50px;
            height: 50px;
            border-radius: 50%;
          }
        }

        span {
          margin-left: 10px;
        }
      }
    }
  }

  .notice-clear {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 0 0 0;
    font-size: 14px;
    text-align: center;
    cursor: pointer;
    border-top: 1px solid #e8eaec;

    i {
      margin-right: 3px;
    }
  }
  .messageList {
    background: #fff;
    top: 52px;
    right: 0;
    z-index: 999;
    cursor: pointer;

    .messageFooter {
      cursor: pointer;
      background: #eee;
      width: 100%;
      height: 44px;
      line-height: 44px;
      text-align: center;
      position: absolute;
      bottom: -40px;
    }

    .messageList-item {
      height: 44px;
      line-height: 44px;
      padding-left: 10px;
      border-bottom: 1px solid #eee;
    }
  }
</style>
